// Create new file: framework/client/helpers/PaymentClientHelperBase.js

import { ComponentBase } from "../core/ComponentBase.js";

export class PaymentClientHelperBase extends ComponentBase {
    constructor(config) {
        super(config);
        if (this.constructor === PaymentClientHelperBase) {
            throw new Error("Abstract classes can't be instantiated.");
        }
    }

    /**
     * Takes the order data from the server and initiates the client-side payment flow.
     * @param {object} orderData - The data returned from the `createRechargeOrder` RPC call.
     * @returns {Promise<void>}
     */
    async initiatePayment(orderData) {
        throw new Error("Method 'initiatePayment()' must be implemented by subclasses.");
    }
}